<template>
    <BaseModal
        :modalWidth="'520px'"
        class="reconciliation-modal-mass-edit"
        @close="onCloseModal"
    >
        <template #modalBody>
            <div class="reconciliation-modal-mass-edit__body">
                <div class="reconciliation-modal-mass-edit__section">
                    <div class="reconciliation-modal-mass-edit__title">
                        Массовое редактирование
                    </div>
                    <div class="reconciliation-modal-mass-edit__subtitle">
                        {{ modalSubtitle }}
                    </div>
                </div>
                <div class="reconciliation-modal-mass-edit__section">
                    <BaseSelectV2
                        canSearch
                        isFullWidth
                        isSimpleCustomTitle
                        :value="optionToEditId"
                        :options="optionsToEdit"
                        :defaultTitle="optionToEditId"
                        label="Выберите параметры для редактирования"
                        class="reconciliation-modal-mass-edit__select"
                        @check="onCheckOptionToEdit"
                    />
                </div>

                <div
                    v-if="parentOptionToEditId"
                    class="reconciliation-modal-mass-edit__section"
                >
                    <BaseSelectV2
                        canSearch
                        isFullWidth
                        isSimpleCustomTitle
                        :value="optionParentToEditData.value"
                        :options="optionParentToEditData.options"
                        :defaultTitle="optionParentToEditData.value"
                        label="Выберите подрядчика"
                        class="reconciliation-modal-mass-edit__select"
                        @onSearchValue="onSearchParentOptions"
                        @lazyload="onLazyLoadParentOptions"
                        @onToggleDropdown="onToggleParentDropdown"
                        @check="onCheckParentValueToEdit"
                    />
                </div>

                <div
                    v-if="optionToEditData && isOptionParentSelected"
                    class="reconciliation-modal-mass-edit__section"
                >
                    <BaseSelectV2
                        v-if="isOptionToEditSelect"
                        canSearch
                        isFullWidth
                        isSimpleCustomTitle
                        :value="optionToEditData.value"
                        :options="optionToEditData.options"
                        :defaultTitle="optionToEditData.value"
                        label="Введите значение для редактирования"
                        class="reconciliation-modal-mass-edit__select"
                        @onSearchValue="onSearchOptions"
                        @lazyload="onLazyLoadOptions"
                        @onToggleDropdown="onToggleDropdown"
                        @check="onCheckValueToEdit"
                    />
                    <BaseSelectMultipleV2
                        v-if="isOptionToEditSelectMultiple"
                        :canSearch="true"
                        :isFullWidth="true"
                        :isOptionsFullWidth="true"
                        :isActionCreate="true"
                        :isActionRemove="true"
                        :value="optionToEditData.value"
                        :options="optionToEditData.options"
                        label="Введите значение для редактирования"
                        class="reconciliation-modal-mass-edit__select"
                        @create="onCreateValueToEdit"
                        @remove="onRemoveValuesToEdit"
                        @apply="onApplyValuesToEdit"
                    />
                    <BaseInputV2
                        v-if="isOptionToEditString"
                        :id="optionToEditData.prop"
                        :type="optionToEditData.type"
                        :value="optionToEditData.value"
                        :label="optionToEditData.label"
                        placeholder="Введите значение"
                        class="reconciliation-modal-mass-edit__input"
                        @onInput="onInputValueToEdit"
                    />
                </div>
                <div class="reconciliation-modal-mass-edit__section">
                    <div class="reconciliation-modal-mass-edit__actions">
                        <div class="reconciliation-modal-mass-edit__action">
                            <LinceButton :theme="'border'" @click="onCloseModal">
                                Отменить
                            </LinceButton>
                        </div>
                        <div class="reconciliation-modal-mass-edit__action">
                            <LinceButton
                                :disabled="
                                    optionToEditId && !optionToEditData.value
                                "
                                :theme="'secondary'"
                                @click="onSaveChanges"
                            >
                                Сохранить
                            </LinceButton>
                        </div>
                    </div>
                </div>
            </div>
        </template>
    </BaseModal>
</template>

<script>
import BaseModal from "../../Base/BaseModal.vue";
import BaseSelectV2 from "../../Base/BaseSelectV2.vue";
import BaseInputV2 from "../../Base/BaseInputV2.vue";

import BaseSelectMultipleV2 from '@/components/Base/BaseSelectMultipleV2.vue';
import UtilNumber from "../../../utils/UtilNumber";

export default {
    name: "ReconciliationModalMassEdit",
    components: {
        BaseModal,
        BaseSelectV2,
        
        BaseInputV2,
        BaseSelectMultipleV2
    },
    props: {
        selectedCount: {
            type: Number,
            default: 0,
        },
        tableRowsToEdit: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            optionToEditId: "",
        };
    },
    computed: {
        modalSubtitle() {
            return `Выбрано: ${UtilNumber.toLocaleNum(this.selectedCount)}`;
        },
        optionsToEdit() {
            return this.tableRowsToEdit?.editableFields?.map((item) => ({
                id: item.prop,
                value: item.label,
            })) ?? [];
        },
        optionToEditData() {
            return this.tableRowsToEdit?.editableFields?.find(
                (item) => String(item?.prop) === String(this.optionToEditId)
            ) ?? {};
        },

        optionParentToEditData() {
            if(!this.parentOptionToEditId){
                return {}
            }

            return this.tableRowsToEdit?.editableFields?.find(
                (item) => String(item?.prop) === String(this.parentOptionToEditId)
            ) ?? {};
        },

        isOptionToEditSelect() {
            return String(this.optionToEditData?.type) === "select";
        },
        isOptionToEditSelectMultiple() {
            return String(this.optionToEditData?.type ?? '') === 'selectMultiple';
        },

        parentOptionToEditId() {
            return String(this.optionToEditData?.prop ?? '').includes('_entity')
                ? String(this.optionToEditData?.prop ?? '').replace('_entity', '')
                : '';
        },

        isOptionToEditString() {
            return String(this.optionToEditData?.type ?? '') === 'string';
        },

        isOptionParentSelected() {
            return !this.parentOptionToEditId || String(this.optionParentToEditData?.value ?? '')
        },
    },
    methods: {
        onCloseModal() {
            this.$emit("onCloseModal");
        },
        onSaveChanges() {
            this.onCloseModal();
            this.$emit("onSaveChanges");
        },
        onCheckOptionToEdit(item) {
            this.optionToEditId = item.id;
        },

        onCheckValueToEdit(option) {
            this.$emit("onChangeRowValue", {
                value: option.id,
                select: this.optionToEditData,
                parent: String(option?.parent ?? '')
            });
        },

        onCheckParentValueToEdit(option) {
            this.$emit("onChangeRowValue", {
                value: option.id,
                select: this.optionParentToEditData,
                parent: String(option?.parent ?? '')
            });
        },

        onInputValueToEdit(value) {
            this.$emit("onChangeRowValue", {
                value,
                select: this.optionToEditData,
                parent: ''
            });
        },

        onSearchParentOptions(value) {
            this.$emit("onSearchOptions", {
                query: value,
                field: this.optionParentToEditData.prop,
            });
        },

        onSearchOptions(value) {
            this.$emit("onSearchOptions", {
                query: value,
                field: this.optionToEditData.prop,
            });
        },

        onLazyLoadParentOptions() {
            this.$emit("onLazyLoadOptions", this.optionParentToEditData);
        },

        onLazyLoadOptions() {
            this.$emit("onLazyLoadOptions", this.optionToEditData);
        },
        onToggleDropdown(isOpen) {
            // if (isOpen && !this.optionToEditData.options.length) {
            if (isOpen) {
                this.$emit("onFetchOptions", this.optionToEditData);
            }
        },

        onToggleParentDropdown(isOpen) {
            if (isOpen) {
                this.$emit("onFetchOptions", this.optionParentToEditData);
            }
        },

        onCreateValueToEdit(valueToEdit = {}) {
            this.$emit('createValueToEdit', this.optionToEditId, valueToEdit);
        },
        onRemoveValuesToEdit(valuesIdsToEdit = []) {
            this.$emit('removeValuesToEdit', this.optionToEditId, valuesIdsToEdit);
        },
        onApplyValuesToEdit(valuesIdsToEdit = []) {
            this.$emit('applyValuesToEdit', this.optionToEditId, valuesIdsToEdit);
        }
    },
};
</script>

<style lang="scss" scoped>
.reconciliation-modal-mass-edit {
    &__section {
        &:not(:last-child) {
            margin-bottom: 20px;
        }
    }

    &__title {
        font-size: 20px;
        font-weight: 500;
        margin-bottom: 10px;
    }

    &__subtitle {
        &_select {
            margin-bottom: 10px;
        }
    }

    &__actions {
        display: flex;
        justify-content: end;
    }

    &__action {
        &:not(:last-child) {
            margin-right: 5px;
        }
    }
}
</style>
